import { InitialState, StoreLoadingEnum } from 'src/store/state/types';
import { IInfo } from './types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import infoApi from './api';
import { RootState } from '../..';

/**
 * Initial State
 */

const initialState: InitialState<IInfo> = {
  loading: StoreLoadingEnum.idle,
  error: null,
  data: {
    apiVersion: '',
    productName: '',
    productVersion: '',
    urls: [],
  },
};

/**
 * Async Actions
 */

export const fetchInfo = createAsyncThunk('info', async () => {
  try {
    const response = await infoApi.fetchInfo();
    return { data: { ...response.data } };
  } catch (e) {
    console.error(e);
  }
});

export const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInfo.pending, (state) => {
        state.loading = StoreLoadingEnum.pending;
      })
      .addCase(fetchInfo.fulfilled, (state, action) => {
        state.loading = StoreLoadingEnum.succeeded;
        const { data } = action.payload!;
        state.data = data;
      })
      .addCase(fetchInfo.rejected, (state) => {
        state.loading = StoreLoadingEnum.failed;
      });
  },
});

export const infoSelector = (state: RootState) => state.info.data;
export const isLoadingSelector = (state: RootState) =>
  state.info.loading === StoreLoadingEnum.pending;
